import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  defaultText: {
    fontFamily: 'Inter',
    fontSize: 16,
    color: colors.newUI.therapist.textBlue100,
  },
});
